<template>
  <div class="switch">
    <div class="d-flex align-items-center mt-2 pb-2">
      <div class="col-3 side-box__content__input custom-control__select ml-3">
        <div>
          <div
            class="custom-control__select__selected"
            :title="
              item.enabled
                ? $t('NOTIFIKACE_ZMENA_JAZYKA_DISABLED_ADMIN')
                : !item.isCustomerAdmin
                  ? $t('NOTIFIKACE_ZMENA_JAZYKA_DISABLED_NONADMIN')
                  : ''
            "
            :class="{
              opened: langOpened,
              disabled: item.enabled || !item.isCustomerAdmin ? true : false
            }"
            @click="
              !item.enabled && item.isCustomerAdmin
                ? (langOpened = langOpened ? false : true)
                : ''
            "
          >
            <div class="d-flex flex-wrap">
              {{ item.language }}
            </div>
          </div>
          <div
            class="custom-control__select__options"
            :class="{ opened: langOpened }"
          >
            <div
              class="custom-control__select__option d-flex align-items-center"
              @click="
                item.language = 'CZ';
                langOpened = false;
              "
            >
              <div class="d-flex">
                <span>CZ</span>
              </div>
            </div>
            <div
              class="custom-control__select__option d-flex align-items-center"
              @click="
                item.language = 'EN';
                langOpened = false;
              "
            >
              <div class="d-flex">
                <span>EN</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Switcher
        :key="item.customer.customerId"
        :value="item.enabled ? true : false"
        :text="true"
        class="col-8 text-center"
        :disabled="!item.isCustomerAdmin ? true : false"
        :field-id="'notificationRegister' + item.customer.customerId"
        @switch="switchNotificationRegistration"
      />
    </div>

    <div v-if="errorsToTranslate.length > 0">
      <error-modal
        :opened="openedError"
        :centered="true"
        :errors="errorsToTranslate"
        @close="openedError = false"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Switcher from "@/components/switcher";
import ErrorModal from "@/components/confirmations/translatedErrors.vue";
export default {
  components: {
    Switcher,
    "error-modal": ErrorModal
  },
  props: {
    item: Object,
    text: Boolean
  },
  data() {
    return {
      errorsToTranslate: [],
      openedError: false,
      langOpened: false
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    closeLang() {
      if (this.langOpened) {
        this.langOpened = false;
      }
    },
    switchNotificationRegistration() {
      this.$store.commit(
        "modals/setWaitingLoader",
        this.$t("Ukládám data, čekejte prosím...")
      );
      this.errorsToTranslate = [];
      let promises = [];
      if (this.item.enabled) {
        promises.push(
          axios
            .delete(
              process.env.VUE_APP_API +
                "/notifications/customers/" +
                this.item.customer.customerId +
                "/emails/" +
                this.item.email,
              {}
            )
            .then(() => {
              this.item.enabled = this.item.enabled ? false : true;
            })
            .catch(error => {
              this.errorsToTranslate.push(error.data);
              return true;
            })
        );
      } else {
        promises.push(
          axios
            .post(
              process.env.VUE_APP_API +
                "/notifications/customers/" +
                this.item.customer.customerId +
                "/emails",
              {
                email: this.item.email,
                language: this.item.language
              }
            )
            .then(() => {
              this.item.enabled = this.item.enabled ? false : true;
            })
            .catch(error => {
              this.errorsToTranslate.push(error.data);
              return true;
            })
        );
      }

      return Promise.all(promises).then(() => {
        this.item.loading = false;
        this.$store.commit("modals/setWaitingLoader", "");
        this.$emit("switch");
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
